import React from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';

import { ButtonComponent as Button } from 'components/button';

import styles from './privacy-message-component.styles.scss';


@inject('privacyStore')
@observer
export class PrivacyMessage extends React.Component {
  render() {
    const message = this.props.privacyStore.message$;
    const read = message === null;

    if (read) { return null; }

    return (
      <div className={styles.PrivacyMessage}>
        <div className={styles.Legal}>
          { message }{' '}
          <Link to='/privacy-policy'>Datenschutzerklärung</Link>.
        </div>
        <div className={styles.ButtonContainer}>
          <Button onClick={this.onClick} className={styles.Button}>
            Zustimmen
          </Button>
        </div>
      </div>
    );
  }

  onClick = (event) => {
    event.stopPropagation();

    this.props.privacyStore.markRead();
  }
}



// WEBPACK FOOTER //
// ./src/components/messages/privacy/privacy-message.component.jsx